export default "<div class=\"text-right\">\r\n    {{ displayData | currency : 'USD' : 'symbol' : digitsInfo }}\r\n</div>";